module.exports = __webpack_public_path__ + "img/analytics-rafiki.ced0c5bf.svg";